import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Flame, ArrowRight } from "lucide-react";
import api from "@/lib/api";


export default function HotLeadBanner() {
  const [hot, setHot] = useState([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get("/hot-leads");
        if (!cancelled) setHot(r.data?.hot_leads || []);
      } catch (e) { /* non-fatal */ }
    };
    load();
    const t = setInterval(load, 60_000); // poll every minute
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!hot || hot.length === 0) return null;

  const top = hot[0];
  const tier = top.cf_score_tier || {};
  const critical = tier.tier === "critical" || top.cf_readiness_score >= 90;

  return (
    <div
      data-testid="hot-lead-banner"
      className={`rounded-sm border ${critical ? "bg-rose-500/10 border-rose-500/40 animate-pulse" : "bg-orange-500/10 border-orange-500/40"} p-3 mb-4 flex items-center gap-3`}
    >
      <Flame className={`h-5 w-5 shrink-0 ${critical ? "text-rose-400" : "text-orange-400"}`} />
      <div className="flex-1 min-w-0">
        <div className="text-xs uppercase tracking-widest text-rose-300 font-medium">
          {critical ? "Critical Lead - Act Within 24 Hours" : "Hot Lead Alert"}
        </div>
        <div className="text-sm text-slate-200 truncate">
          <span className="font-medium">{top.title || top.address}</span>
          <span className="text-slate-500 ml-2">scored {top.cf_readiness_score}</span>
          {top.close_probability_pct != null && (
            <span className="text-slate-500 ml-2">- {top.close_probability_pct}% close prob</span>
          )}
          {hot.length > 1 && (
            <span className="text-slate-500 ml-2">- +{hot.length - 1} more hot</span>
          )}
        </div>
      </div>
      <Link to={`/app/opportunities/${top.oid}`}
            data-testid="hot-lead-banner-cta"
            className="text-xs uppercase tracking-wider px-3 py-1.5 rounded-sm border bg-emerald-500/15 text-emerald-300 border-emerald-500/40 hover:bg-emerald-500/25 inline-flex items-center gap-1 shrink-0">
        Open <ArrowRight className="h-3 w-3" />
      </Link>
    </div>
  );
}
